<script>

    import { createEventDispatcher } from "svelte";


    const dispatch = createEventDispatcher();

    export let planId;
    export let tier;
    export let title;
    export let price;
    export let currency;
    export let subtext;
    export let items;
    export let buttonText;


    const onPlanSelected = () => {

        dispatch('selected', {
            planId: planId,
            tier: tier
        });

    }

</script>


<div class="forms-container forms">

    <img class="plans-logo-small" src="./images/logo.svg" />

    <h2>{title}</h2>

    <h3>{price}</h3>

    <span class="subtext">

        {currency.toUpperCase() + ' / ' + subtext}

    </span>

    {#if items}

        <ul class="keyosh-list">

            {#each items as item}

                <li>
                    {item}
                </li>

            {/each}

        </ul>

    {/if}

    <button on:click={() => onPlanSelected()} class="btn">

        <span>{buttonText}</span>

    </button>

</div>


<style>

    .forms-container {
        font-family: 'Raleway', sans-serif;
        color: #000000;
    }

    .plans-logo-small {
        height: 4vh;
    }

    h2 {
        padding-bottom: 3.6vh;
        font-weight: 300;
        font-size: 3.24vh;
        text-align: center;
    }

    h3 {
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 7.4vh;
        text-align: center;
    }

    .subtext {
        font-size: 1.85vh;
        font-weight: 400;
        text-align: center;
    }

    ul.keyosh-list {
        max-width: 28.6vh;
        padding-top: 0;
        padding-left: 2.6vh;
        margin-top: 5.18vh;
        margin-bottom: 6.11vh;
    }

    ul.keyosh-list li {
        font-size: 1.85vh;
        font-weight: 300;
    }

    ul.keyosh-list li:before {
        width: 0.75vh;
        top: 0.8vh;
    }

    button {
        width: 31.2vh;
        padding: 1.42vh;
        font-size: 1.78vh;
    }

</style>
